var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"portal-notes-container"},[_c('p',[_vm._v(_vm._s(_vm.$t("carriers.modalInfo.portalNotes")))]),_vm._v(" "+_vm._s(_vm.note)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }